import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import SimpleMemberSelect from "../../../components/shared/SimpleMemberSelect";

// Connects to data-controller="administration--teams--fallback-upn-assignments"
export default class extends Controller {
  connect() {
    this.container = document.createElement("div");
    this.element.insertAdjacentElement("afterend", this.container);
    this.root = createRoot(this.container);
    this.root.render(
      <SimpleMemberSelect
        onChange={this.handleChange}
        isDisabled={this.element.dataset.disabled === "true"}
      />,
    );
  }

  handleChange = (membershipId) => {
    this.element.value = membershipId || "";
  };

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
    this.container?.remove();
  }
}
